/* LIRRA theme script. Formulas mirror the generator (lirra/formulas.py, same names, same maths);
   below them the live page wiring for the product page, every family (metaobject) page and collections. */
(function (root) {
  var UNKNOWN = 'unknown';
  var SCENARIOS = {
    table: { surface_cm: 75, clear_min_cm: 75, clear_max_cm: 75 },
    island: { surface_cm: 90, clear_min_cm: 75, clear_max_cm: 75 },
    walkway: { surface_cm: 0, clear_min_cm: 200, clear_max_cm: null }
  };
  function r(x) { return Math.round(x); }
  function f1_diameter(w) {
    var cap = w - 30;
    return { d_min_cm: r(0.5 * w), d_max_cm: Math.min(r(0.67 * w), cap), cap_cm: cap };
  }
  function f1_fits(d, w) {
    if (d == null) return UNKNOWN;
    var x = f1_diameter(w); return d >= x.d_min_cm && d <= x.d_max_cm;
  }
  function model_d_total_range(m) {
    if (m.drop_semantics === 'overall' && m.drop_min_cm != null) return [m.drop_min_cm, m.drop_max_cm];
    if (m.drop_semantics !== 'cable_only' || m.body_height_cm == null || m.cable_max_cm == null) return UNKNOWN;
    return [m.body_height_cm + (m.cable_min_cm || 0), m.body_height_cm + m.cable_max_cm];
  }
  function f2_scenario_range(H, scenario, o) {
    var sc = Object.assign({}, SCENARIOS[scenario || 'table'], o || {});
    var zmin = sc.surface_cm + sc.clear_min_cm;
    var zmax = sc.clear_max_cm == null ? null : sc.surface_cm + sc.clear_max_cm;
    return { z_bottom_min_cm: zmin, z_bottom_max_cm: zmax, d_total_min_cm: zmax == null ? 0 : H - zmax, d_total_max_cm: H - zmin };
  }
  function f2_verdict(H, m, scenario, o) {
    var rng = model_d_total_range(m), sc = f2_scenario_range(H, scenario, o);
    if (rng === UNKNOWN) return { fits: UNKNOWN, scenario: sc };
    var lo = Math.max(rng[0], sc.d_total_min_cm), hi = Math.min(rng[1], sc.d_total_max_cm);
    var out = { fits: lo <= hi && sc.d_total_max_cm >= 0, scenario: sc, model_range_cm: rng };
    if (out.fits) {
      out.d_total_cm = lo; out.z_bottom_cm = H - lo;
      if (m.drop_semantics === 'cable_only') out.cable_cm = lo - m.body_height_cm;
    } else out.reason = rng[0] > sc.d_total_max_cm ? 'too_long' : 'too_short';
    return out;
  }
  function f2_ceiling_span(m, scenario, o) {
    var rng = model_d_total_range(m);
    if (rng === UNKNOWN) return UNKNOWN;
    var sc = f2_scenario_range(0, scenario, o);
    return { from_cm: sc.z_bottom_min_cm + rng[0], to_cm: sc.z_bottom_max_cm == null ? null : sc.z_bottom_max_cm + rng[1] };
  }
  function f3_lumens(emin, emax, len, depth, uf, mf) {
    depth = depth == null ? 0.6 : depth; uf = uf == null ? 0.6 : uf; mf = mf == null ? 0.9 : mf; // D-24
    var a = len * depth, k = uf * mf;
    return { area_m2: Math.round(a * 100) / 100, lm_min: r(emin * a / k), lm_max: r(emax * a / k), assumptions: { depth_m: depth, uf: uf, mf: mf } };
  }
  function f13_renting(m) {
    var ps = m.power_supply, w, d;
    w = ['plug_bs1363', 'battery', 'usb_rechargeable'].indexOf(ps) >= 0 ? true : (ps === 'hardwired' ? false : UNKNOWN);
    if (m.mount === 'table' || m.mount === 'floor') d = true;
    else if ((m.mount === 'adhesive' || m.mount === 'hook') && m.weight_kg != null && m.weight_kg <= 1.5) d = true;
    else if (m.mount === 'pendant' || m.mount === 'ceiling') d = false;
    else d = UNKNOWN;
    return { no_wiring: w, no_drilling: d };
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function three_dates(asOf, h, t) {
    var d0 = new Date(asOf + 'T00:00:00Z'), day = 864e5;
    return { dispatch_by: iso(new Date(+d0 + h[1] * day)), delivery_from: iso(new Date(+d0 + (h[0] + t[0]) * day)), delivery_to: iso(new Date(+d0 + (h[1] + t[1]) * day)) };
  }
  function deliveryDate(now, withYear) {
    // UK calendar days, independent of the visitor's timezone and daylight-saving transitions.
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now || new Date());
    var p = {}; parts.forEach(function (x) { p[x.type] = x.value; });
    var d = new Date(Date.UTC(+p.year, +p.month - 1, +p.day + 14, 12));
    return new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'short', year: withYear ? 'numeric' : undefined }).format(d);
  }
  var L = { UNKNOWN: UNKNOWN, f1_diameter: f1_diameter, f1_fits: f1_fits, model_d_total_range: model_d_total_range,
    f2_scenario_range: f2_scenario_range, f2_verdict: f2_verdict, f2_ceiling_span: f2_ceiling_span,
    f3_lumens: f3_lumens, f13_renting: f13_renting, three_dates: three_dates, deliveryDate: deliveryDate };
  if (typeof module !== 'undefined' && module.exports) { module.exports = L; return; }
  root.LIRRA = L;

  /* ---------- page wiring (browser only) ---------- */
  function m2(cm) { return (cm / 100).toFixed(2) + ' m'; }
  function gbp(x) { return '£' + Math.ceil(x).toLocaleString('en-GB'); }
  function pence(c) { var p = c / 100; return '£' + (p % 1 ? p.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : p.toLocaleString('en-GB')); }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function set(key, val) { $$('[data-out="' + key + '"]').forEach(function (e) { e.textContent = val; }); }
  function num(id, def) { var e = document.getElementById(id); var v = e ? parseFloat(e.value) : NaN; return isNaN(v) ? def : v; }
  function chk(id) { var e = document.getElementById(id); return !!(e && e.checked); }
  function att(el, a, def) { var x = parseFloat(el.getAttribute(a)); return isNaN(x) ? def : x; }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var DATA = null;
  function data() { if (!DATA) { var e = document.getElementById('lirra-data'); try { DATA = e ? JSON.parse(e.textContent) : {}; } catch (x) { DATA = {}; } } return DATA; }
  function inputs() {
    var d = data().inputs || {};
    return { H: Math.round(num('in-ceiling', d.ceiling_cm / 100) * 100), W: num('in-table', d.table_width_cm), T: num('in-table-h', d.table_height_cm) };
  }
  function clearance(i) { var C = (data().inputs || {}).clearance_cm; return { surface_cm: i.T, clear_min_cm: C, clear_max_cm: C }; }
  function dimsOK(w) { return w && model_d_total_range(w) !== UNKNOWN; }
  function fitSetting(w, v) {
    var overall = w.drop_semantics === 'overall';
    return { label: overall ? 'set the overall drop to' : 'set the cable to',
      cm: overall ? v.d_total_cm : v.cable_cm };
  }

  /* Drawing to scale: fixed pixel size per breakpoint, labels at a fixed 12 px outside the drawing. */
  function drawScale(svg, o) {
    var ink = '#1f1d1a', mute = '#6d675e', acc = '#6f5d3f';
    var big = svg.parentElement.clientWidth >= 520, room = big ? 400 : 236, s = room / o.H, y0 = 26, floor = y0 + room;
    var tw = o.W * s, dw = o.dia * s, area = Math.max(tw, dw) + 40, x0 = 12, cx = x0 + area / 2;
    var dimX = x0 + area + 16, width = Math.round(dimX + 118), height = Math.round(floor + 12);
    var yb = y0 + o.dTotal * s, yt = yb - o.body * s, ytab = floor - o.T * s, p = [];
    function r1(x) { return Math.round(x * 10) / 10; }
    function L(x1, y1, x2, y2, c, w) { p.push('<line x1="' + r1(x1) + '" y1="' + r1(y1) + '" x2="' + r1(x2) + '" y2="' + r1(y2) + '" stroke="' + c + '" stroke-width="' + (w || 1) + '"/>'); }
    function T(x, y, t) { p.push('<text x="' + r1(x) + '" y="' + r1(y) + '" font-size="12" font-family="-apple-system,Segoe UI,Roboto,Arial,sans-serif" fill="' + mute + '" dominant-baseline="middle">' + t + '</text>'); }
    L(x0, y0, x0 + area, y0, ink, 2); L(x0, floor, x0 + area, floor, ink, 2);
    T(x0, y0 - 13, 'Ceiling ' + m2(o.H));
    p.push('<rect x="' + r1(cx - tw / 2) + '" y="' + r1(ytab) + '" width="' + r1(tw) + '" height="4" fill="' + ink + '"/>');
    p.push('<rect x="' + r1(cx - 3) + '" y="' + r1(ytab + 4) + '" width="6" height="' + r1(floor - ytab - 4) + '" fill="' + ink + '"/>');
    L(cx, y0, cx, yt, mute, 1.5);
    p.push('<path d="M' + r1(cx - dw / 2) + ' ' + r1(yb) + ' Q' + r1(cx - dw / 2) + ' ' + r1(yt) + ' ' + r1(cx) + ' ' + r1(yt) + ' Q' + r1(cx + dw / 2) + ' ' + r1(yt) + ' ' + r1(cx + dw / 2) + ' ' + r1(yb) + ' Z" fill="' + (o.fits ? acc : '#9a4a2a') + '" fill-opacity=".85"/>');
    L(dimX, y0, dimX, floor, acc, 1);
    var segs = o.overall ? [[y0, yb, o.dTotal + ' cm overall drop']]
      : [[y0, yt, o.cable + ' cm cable'], [yt, yb, o.body + ' cm light']];
    segs = segs.concat([[yb, ytab, (o.z - o.T) + ' cm gap'], [ytab, floor, o.T + ' cm table']]);
    segs.forEach(function (g) { L(dimX - 4, g[0], dimX + 4, g[0], acc, 1); if (g[1] - g[0] >= 15) T(dimX + 9, (g[0] + g[1]) / 2, g[2]); });
    L(dimX - 4, floor, dimX + 4, floor, acc, 1);
    svg.setAttribute('width', width); svg.setAttribute('height', height); svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
    svg.innerHTML = p.join('');
  }

  /* ---------- product page ---------- */
  function activeVariant() { var D = data(); return (D.variants || [])[D.active || 0] || null; }
  function selectVariant() {
    var D = data(), vs = D.variants || [], picked = $$('[data-opt-group]').map(function (g) {
      var b = $('[aria-pressed="true"]', g); return b ? b.getAttribute('data-value') : null; });
    var k = -1;
    vs.forEach(function (v, j) { if (k < 0 && picked.every(function (val, n) { return val == null || v.options[n] === val; })) k = j; });
    if (k < 0) return;
    D.active = k; var v = vs[k];
    $$('input[name="id"][data-variant-input]').forEach(function (e) { e.value = v.id; });
    $$('[data-add]').forEach(function (b) { b.disabled = !v.available; });
    set('sold-out', v.available ? '' : 'This size is not available right now');
    try { if (window.history && window.history.replaceState && D.url) window.history.replaceState({}, '', D.url + '?variant=' + v.id); } catch (e) { /* the address bar is a convenience; buying must not depend on it */ }
  }
  function product() {
    var D = data(), i = inputs(), v0 = activeVariant(); if (!v0) return;
    var w = v0.dims || {}, o = clearance(i), C = o.clear_min_cm;
    set('price', pence(v0.price)); set('ceil', m2(i.H)); set('table', i.W + ' cm'); set('table-h', i.T + ' cm');
    if (w.diameter_cm != null) set('dia', w.diameter_cm);
    var f1 = f1_diameter(i.W); set('f1-min', f1.d_min_cm); set('f1-max', f1.d_max_cm);
    if (w.diameter_cm != null) $$('[data-state="f1"]').forEach(function (e) { e.setAttribute('data-ok', String(f1_fits(w.diameter_cm, i.W))); });
    $$('[data-show="rent"]').forEach(function (e) { e.hidden = !chk('in-rent'); });
    if (D.lux && $('#in-task')) {
      var lx = D.lux[$('#in-task').value] || D.lux[Object.keys(D.lux)[0]];
      var f3 = f3_lumens(lx[0], lx[1], num('in-room-l', D.inputs.room_length_m), num('in-room-w', D.inputs.room_width_m));
      set('lm-min', f3.lm_min.toLocaleString('en-GB')); set('lm-max', f3.lm_max.toLocaleString('en-GB')); set('lux', lx[0] + '–' + lx[1] + ' lx'); set('area', f3.area_m2 + ' m²');
    }
    if (!dimsOK(w) || !D.hangs) return;  // the server text stays: nothing to recalculate without the maker's sizes
    var v = f2_verdict(i.H, w, 'table', o), span = f2_ceiling_span(w, 'table', o), ok = v.fits === true;
    var setting = fitSetting(w, v);
    set('verdict', ok ? 'Fits your ' + m2(i.H) + ' ceiling' + (setting.cm != null ? ' — ' + setting.label + ' ' + setting.cm + ' cm' : '')
      : v.fits === false ? (v.reason === 'too_long' ? 'Too long for your ' + m2(i.H) + ' ceiling' : 'Won’t hang low enough under a ' + m2(i.H) + ' ceiling')
      : 'We can’t check this ceiling yet');
    set('verdict-sub', ok ? 'Bottom of the light at ' + m2(v.z_bottom_cm) + ', ' + C + ' cm above a ' + i.T + ' cm table.' : 'Try the other size or another light.');
    set('span-from', span === UNKNOWN ? '—' : m2(span.from_cm)); set('span-to', span === UNKNOWN || span.to_cm == null ? '—' : m2(span.to_cm));
    set('fit-word', ok ? (setting.cm != null ? setting.label : '') : 'does not fit');
    set('fit-length', ok && setting.cm != null ? setting.cm + ' cm' : ''); set('bottom', ok ? m2(v.z_bottom_cm) : '—');
    $$('[data-state="fit"]').forEach(function (e) { e.setAttribute('data-ok', String(v.fits)); });
    var rng = model_d_total_range(w), dT = ok ? v.d_total_cm : (v.reason === 'too_long' ? rng[0] : rng[1]);
    var svg = $('#scale-svg');
    if (svg && w.body_height_cm != null && dT != null) drawScale(svg, { H: i.H, T: i.T, W: i.W, dia: w.diameter_cm || 40, body: w.body_height_cm, dTotal: dT, cable: dT - w.body_height_cm, overall: w.drop_semantics === 'overall', z: i.H - dT, fits: ok });
  }

  /* ---------- list pages: family (metaobject) pages, collections, search ---------- */
  function listPage() {
    var D = data(), page = D.mode || 'list', i = inputs(), out = [], nfit = 0;
    var pr = $('#f-price'), pmax = pr ? +pr.value : Infinity; if (pr) set('pmax', gbp(pmax));
    var nowire = chk('f-nowire'), nodrill = chk('f-nodrill');
    var mats = $$('button.chip[aria-pressed="true"]').map(function (b) { return b.getAttribute('data-mat'); });
    var hang = page === 'fit' && D.inputs && D.inputs.ceiling_cm, o = null, f1 = null, mid = 0;
    if (hang) { o = clearance(i); f1 = f1_diameter(i.W); mid = (f1.d_min_cm + f1.d_max_cm) / 2; }
    var box = $('#list') || document;  // cards outside the main list (e.g. "fit not established") are not filtered or counted
    $$('.pcard[data-list]', box).forEach(function (card) {
      var ok = true, k = card.getAttribute('data-k'), w = k != null && D.works ? D.works[+k] : null;
      if (hang && dimsOK(w)) {
        var v = f2_verdict(i.H, w, 'table', o);
        ok = v.fits === true && f1_fits(w.diameter_cm, i.W) !== false;
        if (ok) {
          nfit++;
          var line = $('[data-out-card="verdict"]', card);
          var setting = fitSetting(w, v);
          if (line) line.innerHTML = 'For a ' + m2(i.H) + ' ceiling: ' + (setting.cm != null ? (w.drop_semantics === 'overall' ? 'drop' : 'cable') + ' <b>' + setting.cm + ' cm</b>' : 'bottom at <b>' + m2(v.z_bottom_cm) + '</b>');
          card.setAttribute('data-fit', Math.abs((w.diameter_cm || mid) - mid));
        }
      }
      var cm = (card.getAttribute('data-mat') || '').split('|');
      var pass = ok && att(card, 'data-price', 0) <= pmax && (!nowire || card.getAttribute('data-nowire') === 'true') &&
        (!nodrill || card.getAttribute('data-nodrill') === 'true') && (!mats.length || mats.some(function (m) { return cm.indexOf(m) >= 0; }));
      card.hidden = !pass; if (pass) out.push(card);
    });
    var key = $('#sort') ? $('#sort').value : 'fit';
    var rank = function (a, b) { return att(a, 'data-rank', 9999) - att(b, 'data-rank', 9999); };
    var cmp = {
      'fit': function (a, b) { return (att(a, 'data-fitrank', 0) - att(b, 'data-fitrank', 0)) || (att(a, 'data-fit', 0) - att(b, 'data-fit', 0)) || (att(a, 'data-pos', 0) - att(b, 'data-pos', 0)); },
      'price-asc': function (a, b) { return att(a, 'data-price', 0) - att(b, 'data-price', 0) || rank(a, b); },
      'price-desc': function (a, b) { return att(b, 'data-price', 0) - att(a, 'data-price', 0) || rank(a, b); },
      'rating': function (a, b) { return (att(b, 'data-rating', -1) - att(a, 'data-rating', -1)) || rank(a, b); }
    }[key] || function () { return 0; };
    var list = $('#list');
    if (list && $('#sort')) {  // move cards only when the order really changes: moving a card mid-click would swallow the click
      var now = $$('.pcard[data-list]', list), want = now.slice().sort(function (a, b) { return (a.hidden - b.hidden) || cmp(a, b); });
      if (want.some(function (c, n) { return c !== now[n]; })) want.forEach(function (c) { list.appendChild(c); });
    }
    set('count', out.length);
    var empty = $('#none-fit'); if (empty) empty.hidden = out.length > 0;
    if (hang) {
      var sc = f2_scenario_range(i.H, 'table', o);
      $$('tr[data-k]').forEach(function (tr) {
        var w = D.works[+tr.getAttribute('data-k')]; if (!w) return;
        var v = f2_verdict(i.H, w, 'table', o), c = $('[data-c="cable"]', tr), b = $('[data-c="bottom"]', tr);
        if (c) c.textContent = v.fits === true ? (v.cable_cm != null ? v.cable_cm + ' cm' : '—') : (v.fits === false ? 'doesn’t fit' : 'to confirm');
        if (b) b.textContent = v.fits === true ? m2(v.z_bottom_cm) : (v.fits === false ? '—' : 'to confirm');
      });
      set('ceil', m2(i.H)); set('table', i.W + ' cm'); set('table-h', i.T + ' cm');
      set('f1-min', f1.d_min_cm); set('f1-max', f1.d_max_cm); set('f1-cap', f1.cap_cm);
      set('dtotal', sc.d_total_max_cm + ' cm'); set('zbottom', m2(sc.z_bottom_min_cm)); set('n-fit', nfit);
      var a1 = $('.answer1'), d0 = D.inputs;
      if (a1 && (i.H !== d0.ceiling_cm || i.W !== d0.table_width_cm || i.T !== d0.table_height_cm)) {
        a1.innerHTML = 'Hang the bottom of the light at <b>' + m2(sc.z_bottom_min_cm) + '</b>, <b>' + sc.d_total_max_cm + ' cm</b> below the ceiling, and choose Ø <b>' +
          f1.d_min_cm + '</b>–<b>' + f1.d_max_cm + '</b> cm. ' + (nfit === 1 ? '1 model fits.' : nfit + ' models fit.');
      }
      var fig = $('#section-fig'); if (fig) {
        var s = 240 / Math.max(i.H, 1);
        fig.style.setProperty('--ceil', (i.H * s) + 'px'); fig.style.setProperty('--tbl', (i.T * s) + 'px'); fig.style.setProperty('--bottom', (sc.z_bottom_min_cm * s) + 'px');
      }
    }
    var t = $('input[name="tenant"]:checked');
    if (t) { set('tenancy', t.getAttribute('data-label')); $$('[data-tenant]').forEach(function (e) { e.hidden = e.getAttribute('data-tenant') !== t.value; }); }
  }

  /* "See all N": the full list lives in the client index (static JSON chunks); the server draws the first 50.
     Chunked per-type index (generator lirra/client_index.py): index_url = rec file + "#r=<record handle>"; the rec file
     holds the record's rows [row, line, mark] and the part files that hold the rows (part = row / per_part).
     Files uploaded to Shopify Files are read from this shop's own /cdn/shop/files/ path (same origin, any domain). */
  function idxUrl(u) {
    var m = /\/(?:cdn\/shop\/files|s\/files\/\d+\/\d+\/\d+\/\d+\/files)\/([^?#]+)(\?[^#]*)?/.exec(u);
    return m && /^https?:/.test(u) && u.indexOf(location.origin) !== 0 ? location.origin + '/cdn/shop/files/' + m[1] + (m[2] || '') : u;
  }
  function loadIndex(url) {
    var rec = idxUrl(url.split('#')[0]), r = /(?:^|&)r=([^&]+)/.exec(url.split('#')[1] || '');
    var getJ = function (u) { return fetch(u).then(function (x) { if (!x.ok) throw x; return x.json(); }); };
    return getJ(rec).then(function (j) {
      if (!r || !j.recs) return Array.isArray(j) ? j : (j.items || j.works || []);  // single-file list
      var rows = j.recs[decodeURIComponent(r[1])] || [], need = [], base = new URL(rec, location.href);
      rows.forEach(function (e) { var p = Math.floor(e[0] / j.per_part); if (need.indexOf(p) < 0) need.push(p); });
      return Promise.all(need.map(function (p) { return getJ(idxUrl(new URL(j.parts[p], base).href)); })).then(function (got) {
        return rows.map(function (e) {
          var p = Math.floor(e[0] / j.per_part), it = Object.assign({}, got[need.indexOf(p)].rows[e[0] - p * j.per_part]);
          it.line = j.lines[e[1]]; it.mark = j.marks[e[2]]; return it;
        });
      });
    });
  }
  function seeAll() {
    $$('[data-see-all]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-see-all'), list = $('#list'), shown = {};
        $$('.pcard[data-handle]', list).forEach(function (c) { shown[c.getAttribute('data-handle')] = 1; });
        b.disabled = true; b.textContent = 'Loading…';
        loadIndex(url).then(function (items) {
          items.forEach(function (it, n) {
            if (!it || shown[it.handle]) return;
            var a = document.createElement('article');
            a.className = 'pcard'; a.setAttribute('data-list', ''); a.setAttribute('data-handle', it.handle || '');
            a.setAttribute('data-price', it.price_gbp || 0); a.setAttribute('data-rating', it.rating || ''); a.setAttribute('data-rank', it.rank || 9999);
            a.setAttribute('data-pos', 1000 + n); a.setAttribute('data-mat', (it.materials || []).join('|'));
            a.setAttribute('data-nowire', String(!!it.no_wiring)); a.setAttribute('data-nodrill', String(!!it.no_drilling));
            var href = it.url || ('/products/' + it.handle);
            a.innerHTML = '<div class="pimg"><div class="slide">' + (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy" width="400" height="400">' : '') + '</div></div>' +
              '<h3><a href="' + esc(href) + '">' + esc(it.title) + '</a></h3><div class="pline"><span class="p">' + gbp(it.price_gbp || 0) + '</span></div>' +
              (it.line && ['ok', 'no', 'info'].indexOf(it.mark) >= 0 ? '<div class="vline"><span class="mark ' + it.mark + '"></span><span>' + esc(it.line) + '</span></div>' : '') +
              '<div class="arrive">Arrives by <span data-delivery-date>' + deliveryDate() + '</span></div><a class="btn sm" href="' + esc(href) + '">See this light</a>';
            list.appendChild(a);
          });
          b.parentElement.hidden = true; listPage();
        }).catch(function () { b.disabled = false; b.textContent = 'Try again'; });
      });
    });
  }

  function swipes() {
    $$('[data-swipe]').forEach(function (tr) {
      var box = tr.closest('.gallery') || tr.closest('.pimg'), dots = box ? $$('.dot', box) : [], thumbs = box ? $$('.th', box) : [];
      function cur() { return Math.round(tr.scrollLeft / Math.max(tr.clientWidth, 1)); }
      function mark() { var k = cur(); dots.concat(thumbs).forEach(function (d, j) { d.setAttribute('aria-current', String(j % Math.max(dots.length || thumbs.length, 1) === k)); }); }
      function go(k) { tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
      tr.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      thumbs.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-go')); }); });
      mark();
    });
  }

  /* Add to basket without leaving the page (Shopify AJAX cart); plain form post when that fails. */
  function basket() {
    var out = document.getElementById('basket-n');
    function done(b) { var html = b.innerHTML; b.classList.add('done'); b.textContent = 'Added to basket'; setTimeout(function () { b.classList.remove('done'); b.innerHTML = html; }, 1600); }
    $$('form[data-cart-form]').forEach(function (f) {
      f.addEventListener('submit', function (ev) {
        var b = ev.submitter || $('[data-add]', f) || document.querySelector('[data-add][form="' + f.id + '"]');
        refreshDelivery();
        if (!window.fetch) return;
        ev.preventDefault();
        if (window.LIRRA_PREVIEW) { if (out) out.textContent = '(' + ((parseInt((out.textContent || '').replace(/\D/g, ''), 10) || 0) + 1) + ')'; if (b) done(b); return; }
        fetch(f.getAttribute('action') + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
          .then(function (r) { if (!r.ok) throw r; return fetch((data().cart_url || '/cart') + '.js'); })
          .then(function (r) { return r.json(); })
          .then(function (c) { if (out) out.textContent = '(' + c.item_count + ')'; if (b) done(b); })
          .catch(function () { f.submit(); });
      });
    });
  }

  function refreshDelivery() {
    var now = new Date();
    $$('[data-delivery-date]').forEach(function (e) { e.textContent = deliveryDate(now); });
    $$('form[data-cart-form] input[name="properties[Latest delivery]"]').forEach(function (e) { e.value = deliveryDate(now, true); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-mobile-menu]').forEach(function (menu) {
      var toggle = $('summary', menu);
      // Native details exposes its state without JS; enhance it with explicit ARIA when JS runs.
      function sync() { toggle.setAttribute('aria-expanded', String(menu.open)); }
      function close() { menu.open = false; sync(); }
      sync();
      menu.addEventListener('toggle', sync);
      menu.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
      document.addEventListener('click', function (e) { if (!menu.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.open) { close(); toggle.focus(); }
      });
      menu.addEventListener('focusout', function (e) { if (e.relatedTarget && !menu.contains(e.relatedTarget)) close(); });
      window.matchMedia('(min-width: 960px)').addEventListener('change', function (e) { if (e.matches) close(); });
    });
    var isProduct = document.body.getAttribute('data-page') === 'product', run = isProduct ? product : listPage;
    $$('input, select').forEach(function (e) { if (!e.closest('form[data-cart-form]') && !e.closest('.search')) { e.addEventListener('input', run); e.addEventListener('change', run); } });
    $$('[data-opt-group]').forEach(function (g) {
      $$('[data-value]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-value]', g).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          selectVariant(); run();
        });
      });
    });
    $$('button.chip:not(.apply)').forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-pressed', String(b.getAttribute('aria-pressed') !== 'true')); run(); }); });
    $$('[data-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = document.getElementById(b.getAttribute('data-toggle')), open;
        if (!t) return;
        if (t.classList.contains('filters')) { open = t.classList.toggle('open'); } else { t.hidden = !t.hidden; open = !t.hidden; }
        b.setAttribute('aria-expanded', String(open));
      });
    });
    $$('[data-open]').forEach(function (a) { a.addEventListener('click', function () { var d = document.getElementById(a.getAttribute('data-open')); if (d) d.open = true; }); });
    var first = document.getElementById('checks');
    if (first && window.matchMedia('(max-width: 767px)').matches) first.open = false;
    var sortSel = document.querySelector('select[data-sort-url]');
    if (sortSel) sortSel.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sortSel.value); window.location.href = u.toString(); });
    refreshDelivery(); swipes(); basket(); seeAll(); run();
    window.addEventListener('pageshow', refreshDelivery);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshDelivery(); });
    setInterval(refreshDelivery, 60000);
    window.addEventListener('resize', function () { if (isProduct) run(); });
  });
})(this);
